import { useEffect, useState } from 'react';
import { Download, Smartphone, X } from 'lucide-react';

/** Shows an "Install app" button on login once Chrome fires beforeinstallprompt. */
export const InstallPwaButton = ({ className = '' }) => {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener('beforeinstallprompt', h);
    const inst = () => setInstalled(true);
    window.addEventListener('appinstalled', inst);
    // iOS standalone detection
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) setInstalled(true);
    return () => {
      window.removeEventListener('beforeinstallprompt', h);
      window.removeEventListener('appinstalled', inst);
    };
  }, []);

  const handleInstall = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome !== 'accepted') setDismissed(true);
    setPrompt(null);
  };

  if (installed || !prompt || dismissed) return null;

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="install-pwa-wrapper">
      <button
        onClick={handleInstall}
        className="flex-1 h-11 rounded-xl bg-brand-primary hover:bg-brand-primary-hover text-white text-sm font-semibold flex items-center justify-center gap-2 shadow-sm active:scale-95 transition-all"
        data-testid="install-pwa-btn"
      >
        <Smartphone size={16} />
        <span>Install Quantora App</span>
        <Download size={14} />
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="w-11 h-11 rounded-xl bg-brand-bg border border-brand-border flex items-center justify-center text-brand-text-secondary"
        data-testid="install-pwa-dismiss"
        aria-label="Dismiss install prompt"
      >
        <X size={16} />
      </button>
    </div>
  );
};
